import debounce from 'lodash.debounce'

function setHeaderHeight() {
  const headerHeight = document.querySelector( '.header' )
  document.documentElement.style.setProperty( '--header-height', `${headerHeight.offsetHeight}px` )
}

function init() {
  setHeaderHeight()
  window.addEventListener( 'resize', debounce( setHeaderHeight, 250 ) )
}

export default {
  init,
}
